import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {userRegister} from "../../services/userRegister";
import {langRegister} from "../../services/langRegister";
import queryString from 'query-string'
import {marketRegister} from "../../services/marketRegister";

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoadingButton: false,
            error: false,
            email: ""
        };
    };

    componentWillMount(){
        window.scrollTo(0, 0);
        //document.addEventListener("keydown", this._handleKeyDown.bind(this));
    }

    componentWillUnmount() {
        //document.removeEventListener("keydown", this._handleKeyDown.bind(this));
    }

    _handleKeyDown(event){
        var ENTER_KEY = 13;
        switch( event.keyCode ) {
            case ENTER_KEY:
                this._next();
                break;
            default:
                break;
        }
    }

    _next(){
        if(this._emailValidation(this.state.email)){
            this.setState({isLoadingButton: true, error: false}, () => {
                this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/login/pin/" + this.state.email + "/" + this.props.location.search)
            });
        }else{
            this.setState({error: true});
        }
    }

    _emailValidation(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    _register(){
        this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/register" + this.props.location.search);
    }

    _renderButton(){
        if (!this.state.isLoadingButton) {
            return (this._renderText("item_8"));
        } else {
            return (<BeatLoader size={9} color={'#ffffff'} loading={true}/>);
        }
    }

    _renderText(item) {
        return langRegister.get("login", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne view={"login"} props={this.props}/>
                <div className={Styles.container}>
                    <div className={Styles.title}>
                        {this._renderText("item_1")}
                    </div>
                    <div className={Styles.subtitle}>
                        {this._renderText("item_2")}
                    </div>
                    <input
                        className={
                            cx(Styles.input,
                                {
                                    [Styles.inputError]: this.state.error,
                                })
                        }
                        type={"email"}
                        placeholder={this._renderText("item_3")}
                        value={this.state.email}
                        onChange={(event) => this.setState({email: event.target.value})}
                    />
                    <div onClick={() => this._next()} className={Styles.button}>
                        {this._renderButton()}
                    </div>
                    <div className={Styles.text}>
                        {this._renderText("item_6")}<span onClick={() => this._register()} className={Styles.textBold}>{this._renderText("item_7")}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/pages/login/component.js